import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Footer';
import lifewinkLogoWhite from '../../assets/lifewink-logo-white.png';
import './LegalLayout.css';

const LegalLayout = ({ children }) => (
  <div className="legal-page">
    <div className="legal-page-inner">
      <div className="legal-header">
        <Link to="/">
          <img
            src="https://lifewink-common.s3.us-east-2.amazonaws.com/emailAssets/lifewink_logo.png"
            className="legal-logo legal-logo-mobile"
            alt="LifeWink Logo"
          />
          <img
            src={lifewinkLogoWhite}
            className="legal-logo legal-logo-desktop"
            alt="LifeWink Logo"
          />
        </Link>
      </div>
      <div className="legal-card">
        <div className="legal-card-body">{children}</div>
        <Footer />
      </div>
    </div>
  </div>
);

export default LegalLayout;
